<template>
  <div class="examed-list">
    <Header></Header>
    <div class="main">
      <!-- <div class="left-mian">
        <div class="left-item" :class="{ act: titleIndex == index }" v-for="(item, index) in categoryList" :key="index" @click="categoryClick(item, index)" v-html="item.ExamCategoryName" @mousemove="titleActive(index)"></div>
      </div> -->
      <div v-if="list.length > 0" class="right-mian">
        <div v-for="(item, index) in list" :key="index" class="item-wrap">
          <div class="item-top" :class="index % 2 == 0 ? 'left' : 'right'">
            <p style="font-size: 20px;color:#fac1c1;">{{ item.ExamCategoryName }}</p>
            <!-- <p>考试次数：{{ item.ExamCount }}次</p>
            <p>考试人数：{{ item.ExamUserCount}}人</p>
            <p>本人考试次数：{{item.MySelfExamCount}}次</p> -->
          </div>
          <div class="item-bottom" @click="pathTo(item)" :class="index % 2 == 0 ? 'left-bottom' : 'right-bottom'">
            <span>进入已考列表</span><i class="el-icon-right"></i>
          </div>
        </div>
      </div>
      <el-empty v-else description="暂无符合的数据"></el-empty>
    </div>
  </div>
</template>

<script>
import  Header  from '@/components/Header.vue'
export default {
  name: 'ExamedList',
  components:{
    Header
  },
  data() {
    return {
      list:[],
    }
  },
  mounted(){
    this.$api.HJExaminedCategoryList().then(res=>{
      if(res.Success){
        this.list=res.Data
      }else this.$message.error(res.Msg)
    })
  },
  methods:{
    pathTo(item) {
      this.$router.push({
        path: 'ExamedListDetail',
        query: {
          categoryId:item.ExamCategoryId||1,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.examed-list{
  padding-top: 86px;
  height: 100%;
  overflow: hidden;
  .main {
    border-radius: 5px;
    background-color: #fff;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    height: calc(100% - 10px);
    overflow: hidden;
    // box-shadow: 0px 12px 20px 0px rgba(208, 208, 208, 0.5);
    box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
    display: flex;

    .left-mian {
      width: 150px;
      margin: 10px 0;

      .left-item {
        font-size: 16px;
        padding: 20px 10px 20px 13px;
        display: flex;
        justify-content: flex-end;
        text-align: end;

        >p {
          font-size: 16px;
        }
      }

      .act {
        background-color: #49c1d92e;
        border-right: 2px solid #4384f4;
        font-size: 20px;
      }
    }

    .item-wrap {
      height: 241px;
      margin: 0px 20px 20px 20px;
    }

    .item-wrap:hover {
      transform: translate3d(0, -2px, 0);
      box-shadow: 0px 8px 26px 0px #D7ECEB;
    }

    .right-mian {
      padding: 20px 0 20px 20px;
      // width: calc(100% - 150px);
      overflow: scroll;
      box-shadow: -5px 0 10px -5px rgba(208, 208, 208, 0.5);
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .item-top {
        height: 186px;
        width: 345px;
        padding: 38px 18px;
        box-sizing: border-box;
        border-radius: 8px 8px 0 0;
        position: relative;
        z-index: 1;
        p{
          color: #fff;
          margin-top: 30px;
        }
      }

      .item-bottom {
        height: 56px;
        width: 345px;
        box-shadow: 0px 8px 26px 0px rgba(229, 229, 229, 0.5);
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 0 0 8px 8px;
        padding: 0 18px;
        box-sizing: border-box;
        cursor: pointer;

        span {
          font-size: 16px;
          color: #fff;
        }

        i {
          color: #fff;
          font-size: 18px;
        }
      }

      .left {
        background: #517B81;

      }

      .left-bottom {
        background: #164046;
      }

      .right {
        background: #65A27C;
      }

      .right-bottom {
        background: #23402E;
      }

      .left::after {
        content: '';
        width: 159px;
        height: 135px;
        background: url(https://static.qidianla.com/view/www/pc/index_section_icon1.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: -1;
      }

      .right::after {
        content: '';
        width: 159px;
        height: 135px;
        background: url(https://static.qidianla.com/view/www/pc/index_section_icon2.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: -1;
      }
    }

    .el-empty {
      margin: auto;
    }
  }
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}

</style>